<template>
  <div id="Update">
    <van-panel title="软件更新" desc status>
      <div class="text-left">
        <van-cell-group>
          <van-cell title="说明" :label="updateMemo" />
          <van-cell title="文件" :label="updateTips" />
          <van-cell title="日期" :label="updateDate" />
        </van-cell-group>
      </div>
      <div class="m-2">
        <van-progress v-if="progress > 0" :percentage="progress" />
      </div>
      <div slot="footer" v-if="updateBtnShow">
        <van-button class="w-100" type="info" @click="updateBtn()">更新</van-button>
      </div>
    </van-panel>

    <van-steps direction="vertical" class="text-left" v-show="false">
      <van-step>
        <label>当前 Ver {{ this.Ver() }}：{{this.updateMemo}}</label>
      </van-step>
      <van-step>
        <label>版本 Ver 3.0：优化数据查询方式</label>
      </van-step>
      <van-step>
        <label>版本 Ver 2.5：增加机构工作人员管理插件</label>
      </van-step>
      <van-step>
        <label>版本 Ver 2.1：工作任务插件动态管理</label>
      </van-step>
      <van-step>
        <label>版本 Ver 2.0：优化用户操作体验</label>
      </van-step>
      <van-step>
        <label>版本 Ver 1.7：组件化程序结构</label>
      </van-step>
      <van-step>
        <label>版本 Ver 1.5：插件化设计工作环节</label>
      </van-step>
      <van-step>
        <label>版本 Ver 1.0：实现考务基础功能</label>
      </van-step>
    </van-steps>
  </div>
</template>
<script>
export default {
  name: "Update",
  data() {
    return {
      progress: -1,
      onlineVer: {},
      updateMemo: "",
      updateTips: "",
      updateDate: "",
      updateBtnShow: false
    };
  },
  methods: {
    updateBtn: function() {
      if (window.plus) {
        if (this.progress >= 0) {
          this.$toast("正在下载更新包");
        } else {
          this.progress = 0;
          // window.plus.nativeUI.showWaiting("正在下载.");
          // H5plus处理下载更新事件
          var dtask = window.plus.downloader.createDownload(
            this.onlineVer.DownURL,
            { method: "POST" },
            function(d, status) {
              if (status == 200) {
                //sleep(500); 延时打开
                //下载完成后调用html5plus安装方法
                window.plus.runtime.install(d.filename);
              } else {
                this.progress = -1;
                //提示下载失败
                window.plus.nativeUI.showWaiting("下载失败");
              }
              window.plus.nativeUI.closeWaiting();
            }
          );
          //为下载添加监听事件
          dtask.addEventListener("statechanged", this.onStateChanged, true);
          dtask.start();
        }
      } else {
        // eslint-disable-next-line no-console
        console.log("不支持Html5Plus操作");
      }
    },
    onStateChanged(download, status) {
      if (download.state == 4 && status == 200) {
        this.progress = -1;
      } else {
        this.progress = parseInt(
          (download.downloadedSize / download.totalSize) * 100
        );
      }
    }
  },
  created() {},
  mounted() {
    var thisVer = this.Ver();
    this.getVersion(this, res => {
      if (res.code == 20000) {
        this.onlineVer = res.data;
        if (thisVer == res.data.Version) {
          this.updateTips = "当前版本:" + thisVer + ", 没有更新";
        } else {
          this.updateMemo =
            "新版 " + res.data.Version + " 更新内容 : " + res.data.VersionMemo;
          this.updateTips = "文件大小:" + res.data.Site;
          this.updateDate = "更新时间:" + res.data.Date;
          this.updateBtnShow = true;
        }
      } else {
        this.$toast(res.message);
      }
    });
  }
};
</script>
<style scoped>
</style>
